export default __webpack_public_path__ + "static/media/IconDesc_LiquidSulfuricAcid_Pipe.256.1bbada0f.png";